import { CanDeactivateFn } from '@angular/router';
import { ArquivoRetornoCadastroComponent } from './arquivo-retorno-cadastro.component';

/** Impede trocar de rota enquanto o processamento do arquivo ainda está em execução. */
export const cadastroArquivoRetornoGuard: CanDeactivateFn<ArquivoRetornoCadastroComponent> = (component) =>
  !component.processamentoEmAndamento;
